// extracted by mini-css-extract-plugin
export default {"header":"App_header__QMSv0","link":"App_link__sVggN","button":"App_button__yr+fk","subLink":"App_subLink__iBnm9","dropdownFooter":"App_dropdownFooter__BvO7q"};